exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../node_modules/css-loader/index.js!../../node_modules/fixed-data-table/dist/fixed-data-table.css"), "");
exports.i(require("-!./../../node_modules/css-loader/index.js!./_fonts.css"), "");

// module
exports.push([module.id, "body,html{font-family:Open Sans;height:100%;margin:0;padding:0;overflow:hidden}.log-data{font-family:Inconsolata}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/sass/style.scss
// module id = 123
// module chunks = 0